export const USER_INVITED = "USER_INVITED";
export const TRANSFER_ACCEPTED = "TRANSFER_ACCEPTED";
export const USER_REMOVED = "USER_REMOVED";
